import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { fromEvent, of } from 'rxjs';
import { pairwise, switchMap, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'app-firma-cancelacion',
  templateUrl: './firma-cancelacion.component.html',
  styleUrls: ['./firma-cancelacion.component.css']
})
export class FirmaCancelacionComponent implements AfterViewInit {

  @Output('eventFirm')eventFirm = new EventEmitter();

  @ViewChild('canvasPadre', {read: ElementRef, static: true}) public canvasPadre: ElementRef;
  @ViewChild('normalCanvas') public normalCanvas: ElementRef;
  @ViewChild('scaledCanvas') public scaledCanvas: ElementRef;

  private initialPointDraw: {x: number, y: number}
  private cContext: CanvasRenderingContext2D;
  private canvasE1: HTMLCanvasElement;
  private canCont: HTMLElement;
  private scaledCanvasHTMLElement: HTMLCanvasElement

  private static FIRMA_WIDTH = 200;
  private static FIRMA_HEIGTH = 94;

  constructor() { }

  ngAfterViewInit() {
    this.canCont = this.canvasPadre.nativeElement;
    this.canvasE1 = this.normalCanvas.nativeElement;
    this.cContext = this.canvasE1.getContext('2d');    

    this.canvasE1.width = this.canCont.offsetWidth;
    this.canvasE1.height = this.canCont.offsetHeight;

    this._clearCanvas();

    this.capturaEventos(this.canvasE1);

    this.canvasE1.addEventListener('touchstart', (event) => {
      document.body.style.overflow = "hidden";
    })
    this.canvasE1.addEventListener('touchend', (event) => {
      document.body.style.overflow = "scroll";
    })
    this.capturaEventosTouch(this.canvasE1);
  }


  limpiarFirma() {
    this._clearCanvas();
  }

  _clearCanvas() {
    this.cContext.lineWidth = 2;
    this.cContext.lineCap = 'round';
    this.cContext.strokeStyle = '#000';
    this.cContext.fillStyle = '#fff';
    this.cContext.fillRect(0, 0, this.canvasE1.width, this.canvasE1.height);
    this.initialPointDraw = null;
  }

  private capturaEventos(canvasE1: HTMLCanvasElement) {
    fromEvent(canvasE1, 'mousedown')
      .pipe(
        tap((e: MouseEvent) => {
          const rect = canvasE1.getBoundingClientRect();
          if(this.initialPointDraw == null || this.initialPointDraw == undefined){
            this.initialPointDraw = {
              x: e.clientX - rect.left,
              y: e.clientY - rect.top,
            };
          }
        }),
        switchMap((e) => {
          return fromEvent(canvasE1, 'mousemove').pipe(
            takeUntil(fromEvent(canvasE1, 'mouseup').pipe(
              switchMap(res => {
                return of(res);
              })
            )),
            takeUntil(fromEvent(canvasE1, 'mouseleave').pipe(
              switchMap(res => {
                return of(res);
              }))),
            pairwise()
          );
        })
      )
      .subscribe((res: [MouseEvent, MouseEvent]) => {

//console.log("subscribe moves event: ", res);

        const rect = canvasE1.getBoundingClientRect();

        const prevPos = {
          x: res[0].clientX - rect.left,
          y: res[0].clientY - rect.top,
        };

        const currentPos = {
          x: res[1].clientX - rect.left,
          y: res[1].clientY - rect.top,
        };

        //console.log("prevPos", prevPos);

        this.dibujarFirma(prevPos, currentPos);
      });
  }

  private dibujarFirma(
    prevPos: { x: number; y: number },
    currentPos: { x: number; y: number }
  ) {
    if (!this.cContext) {
      return;
    }

    this.cContext.beginPath();

    if (prevPos) {
      this.cContext.moveTo(prevPos.x, prevPos.y);
      this.cContext.lineTo(currentPos.x, currentPos.y);
      this.cContext.stroke();
    }
  }

  private capturaEventosTouch(canvasE1: HTMLCanvasElement) {
    fromEvent(canvasE1, 'touchstart')
      .pipe(
        tap((e: TouchEvent) => {
          console.log("touch event: ", e)
          const rect = canvasE1.getBoundingClientRect();
          if(this.initialPointDraw == null || this.initialPointDraw == undefined){
            this.initialPointDraw = {
              x: e.touches[0].clientX - rect.left,
              y: e.touches[0].clientY - rect.top,
            };
          }
        }),
        switchMap((e) => {
          return fromEvent(canvasE1, 'touchmove').pipe(
            takeUntil(fromEvent(canvasE1, 'touchend').pipe(
              switchMap(res => {
                return of(res);
              })
            )),
            takeUntil(fromEvent(canvasE1, 'touchleave').pipe(
              switchMap(res => {
                return of(res);
              })
            )),
            takeUntil(fromEvent(canvasE1, 'touchcancel').pipe(
              switchMap(res => {
                return of(res);
              })
            )),
            pairwise()
          );
        })
      )
      .subscribe((res: [TouchEvent, TouchEvent]) => {
        const rect = canvasE1.getBoundingClientRect();


        if (window.innerWidth <= 500) {
          const prevPos = {
            x: res[0].touches[0].clientX - rect.left,
            y: res[0].touches[0].clientY - rect.top,
          };

          const currentPos = {
            x: res[1].touches[0].clientX - rect.left,
            y: res[1].touches[0].clientY - rect.top,
          };

          this.dibujarFirma(prevPos, currentPos);
          return;
        }


        if (window.innerWidth <= 768) {
          const prevPos = {
            x: (((res[0].touches[0].clientX - rect.left) / 2) + 5),
            y: (((res[0].touches[0].clientY - rect.top) / 2) + 5)
          };

          const currentPos = {
            x: (((res[1].touches[0].clientX - rect.left) / 2) + 5),
            y: (((res[1].touches[0].clientY - rect.top) / 2) + 5)
          };

          this.dibujarFirma(prevPos, currentPos);
          return;
        }


        if (window.innerWidth <= 1024) {
          const prevPos = {
            x: (((res[0].touches[0].clientX - rect.left) / 3) + 5),
            y: (((res[0].touches[0].clientY - rect.top) / 3) + 5)
          };

          const currentPos = {
            x: (((res[1].touches[0].clientX - rect.left) / 3) + 5),
            y: (((res[1].touches[0].clientY - rect.top) / 3) + 5)
          };

          this.dibujarFirma(prevPos, currentPos);
          return;
        }
      });
  }



  _createCanvasWithImageData(imageData: ImageData) {
    const finalCanvas: HTMLCanvasElement = document.createElement('canvas');
    const finalContext = finalCanvas.getContext('2d');

    finalCanvas.width = 400;
    finalCanvas.height = 186;
   
    /* const dxStart = (finalCanvas.width / 2) - (this.canvasE1.width / 2);
    const dyStart = (finalCanvas.height / 2) - (this.canvasE1.height / 2); */

    finalContext.globalCompositeOperation = 'destination-over';
    finalContext.putImageData(imageData, 10, 10);

    finalContext.beginPath();
    //finalContext.globalCompositeOperation = 'destination-over';
    finalContext.lineWidth = 2;
    finalContext.lineCap = 'round';
    finalContext.fillStyle = '#fff';
    finalContext.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

    return finalCanvas;
  }


  /**
   * 
   * @param canvas Elemento de tipo HTMLCanvasElemento al que se le realizara la escala 
   * @param scalingPercentage porcenteja al que debe ser escalado, debe ser entre 0 y 1
   */
  resizeTo(canvas: HTMLCanvasElement, scalingPercentage: number) {    

    /* Operacion de escalado */
    let scaledWidth =  this.canvasE1.width * scalingPercentage;
    let scaledHeight = this.canvasE1.height * scalingPercentage;

    /* Asignacion del nuevo tamaño de la imagen - escalado */
    this.scaledCanvasHTMLElement = this.scaledCanvas.nativeElement;
    this.scaledCanvasHTMLElement.width = scaledWidth;
    this.scaledCanvasHTMLElement.height = scaledHeight;

    /* Obtencion del contexto del nuevo canvas y dibujado de la imagen escalandola */
    const scContext = this.scaledCanvasHTMLElement.getContext('2d');
    scContext.drawImage(this.scaledCanvasHTMLElement, 0 , 0, 
      scaledWidth,scaledHeight, 50, 50, scaledWidth, scaledHeight);
      scContext.globalCompositeOperation = 'destination-over';

    scContext.beginPath();
    scContext.lineWidth = 2;
    scContext.lineCap = 'round';
    scContext.fillStyle = '#fff';
    scContext.fillRect(0,0,this.scaledCanvasHTMLElement.width, this.scaledCanvasHTMLElement.height)

    return canvas.toDataURL('image/jpeg');
  }

  guardarFirma() {
    const signatureScaledImage = this.resizeTo(this.normalCanvas.nativeElement, 1.5);
    this.eventFirm.emit({firma: signatureScaledImage});
  }

}
